import DateTimeUtil from '@/util/date-time-util';

export default {
  methods: {
    getWorkScheduleDeviation(timePair) {
      const overtime = timePair.workScheduleMinuteDeviation > 0;
      const type = overtime ? '+' : '-';

      return `${this.$t('workSchedules.deviation')}:
        ${type}${DateTimeUtil.getFormattedDuration(Math.abs(timePair.workScheduleMinuteDeviation))}`;
    },
  },
};
